var setupOidcConfig = function setupOidcConfig(_ref) {
  var client_id = _ref.client_id,
    redirect_uri = _ref.redirect_uri,
    silent_redirect_uri = _ref.silent_redirect_uri,
    scope = _ref.scope,
    authority = _ref.authority,
    _ref$monitor_session = _ref.monitor_session,
    monitor_session = _ref$monitor_session === void 0 ? false : _ref$monitor_session,
    refresh_time_before_tokens_expiration_in_second = _ref.refresh_time_before_tokens_expiration_in_second,
    _ref$service_worker_r = _ref.service_worker_relative_url,
    service_worker_relative_url = _ref$service_worker_r === void 0 ? '/OidcServiceWorker.js' : _ref$service_worker_r,
    _ref$service_worker_o = _ref.service_worker_only,
    service_worker_only = _ref$service_worker_o === void 0 ? true : _ref$service_worker_o;
  if (refresh_time_before_tokens_expiration_in_second) {
    return {
      client_id: client_id,
      redirect_uri: redirect_uri,
      silent_redirect_uri: silent_redirect_uri,
      scope: scope,
      authority: authority,
      monitor_session: monitor_session,
      refresh_time_before_tokens_expiration_in_second: refresh_time_before_tokens_expiration_in_second,
      service_worker_relative_url: service_worker_relative_url,
      service_worker_only: service_worker_only
    };
  }
  return {
    client_id: client_id,
    redirect_uri: redirect_uri,
    silent_redirect_uri: silent_redirect_uri,
    scope: scope,
    authority: authority,
    monitor_session: monitor_session,
    service_worker_relative_url: service_worker_relative_url,
    service_worker_only: service_worker_only
  };
};

export { setupOidcConfig };
